import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IMessageFieldsFragment = {
  activityId?: string | null
  photoId?: string | null
  id?: any | null
  text?: string | null
  threadId?: any | null
  userId?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  projectId: any
  readBy?: Array<{ isRead: boolean; userId?: any | null } | null> | null
  attachments?: Array<{
    fileName: string
    size: string
    url: string
  } | null> | null
}

export type IMessagesByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IMessagesByProjectIdQuery = {
  messages?: {
    data: Array<{
      activityId?: string | null
      photoId?: string | null
      id?: any | null
      text?: string | null
      threadId?: any | null
      userId?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      projectId: any
      readBy?: Array<{ isRead: boolean; userId?: any | null } | null> | null
      attachments?: Array<{
        fileName: string
        size: string
        url: string
      } | null> | null
    }>
  } | null
}

export type IListenMessagesByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenMessagesByProjectIdSubscription = {
  message?: {
    id?: any | null
    item?: {
      activityId?: string | null
      photoId?: string | null
      id?: any | null
      text?: string | null
      threadId?: any | null
      userId?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      projectId: any
      readBy?: Array<{ isRead: boolean; userId?: any | null } | null> | null
      attachments?: Array<{
        fileName: string
        size: string
        url: string
      } | null> | null
    } | null
  } | null
}

export type ISaveMessageMutationVariables = Types.Exact<{
  message: Types.IMessageInput
}>

export type ISaveMessageMutation = {
  saveMessage?: {
    activityId?: string | null
    photoId?: string | null
    id?: any | null
    text?: string | null
    threadId?: any | null
    userId?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    projectId: any
    readBy?: Array<{ isRead: boolean; userId?: any | null } | null> | null
    attachments?: Array<{
      fileName: string
      size: string
      url: string
    } | null> | null
  } | null
}

export type ISaveManyMessagesMutationVariables = Types.Exact<{
  messages:
    | Array<Types.InputMaybe<Types.IMessageInput>>
    | Types.InputMaybe<Types.IMessageInput>
}>

export type ISaveManyMessagesMutation = {
  saveManyMessages?: Array<{ id?: any | null } | null> | null
}

export type ISaveWorkflowMessageMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ObjectId']['input']
  message: Types.IMessageInput
}>

export type ISaveWorkflowMessageMutation = {
  savePermitMessage?: {
    activityId?: string | null
    photoId?: string | null
    id?: any | null
    text?: string | null
    threadId?: any | null
    userId?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    projectId: any
    readBy?: Array<{ isRead: boolean; userId?: any | null } | null> | null
    attachments?: Array<{
      fileName: string
      size: string
      url: string
    } | null> | null
  } | null
}

export const MessageFieldsFragmentDoc = gql`
  fragment MessageFields on Message {
    activityId
    photoId
    id
    readBy {
      isRead
      userId
    }
    text
    threadId
    userId
    createdAt
    updatedAt
    attachments {
      fileName
      size
      url
    }
    projectId
  }
`
export const MessagesByProjectIdDocument = gql`
  query MessagesByProjectId($projectId: ObjectId!) {
    messages(limit: 1000000, projectId: $projectId) {
      data {
        ...MessageFields
      }
    }
  }
  ${MessageFieldsFragmentDoc}
`

/**
 * __useMessagesByProjectIdQuery__
 *
 * To run a query within a React component, call `useMessagesByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useMessagesByProjectIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IMessagesByProjectIdQuery,
    IMessagesByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IMessagesByProjectIdQuery,
    IMessagesByProjectIdQueryVariables
  >(MessagesByProjectIdDocument, options)
}
export function useMessagesByProjectIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IMessagesByProjectIdQuery,
    IMessagesByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IMessagesByProjectIdQuery,
    IMessagesByProjectIdQueryVariables
  >(MessagesByProjectIdDocument, options)
}
export type MessagesByProjectIdQueryHookResult = ReturnType<
  typeof useMessagesByProjectIdQuery
>
export type MessagesByProjectIdLazyQueryHookResult = ReturnType<
  typeof useMessagesByProjectIdLazyQuery
>
export type MessagesByProjectIdQueryResult = Apollo.QueryResult<
  IMessagesByProjectIdQuery,
  IMessagesByProjectIdQueryVariables
>
export const ListenMessagesByProjectIdDocument = gql`
  subscription ListenMessagesByProjectId($projectId: ObjectId!) {
    message(projectId: $projectId) {
      id
      item {
        ...MessageFields
      }
    }
  }
  ${MessageFieldsFragmentDoc}
`

/**
 * __useListenMessagesByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenMessagesByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenMessagesByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenMessagesByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenMessagesByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenMessagesByProjectIdSubscription,
    IListenMessagesByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenMessagesByProjectIdSubscription,
    IListenMessagesByProjectIdSubscriptionVariables
  >(ListenMessagesByProjectIdDocument, options)
}
export type ListenMessagesByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenMessagesByProjectIdSubscription
>
export type ListenMessagesByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenMessagesByProjectIdSubscription>
export const SaveMessageDocument = gql`
  mutation SaveMessage($message: MessageInput!) {
    saveMessage(message: $message) {
      ...MessageFields
    }
  }
  ${MessageFieldsFragmentDoc}
`
export type ISaveMessageMutationFn = Apollo.MutationFunction<
  ISaveMessageMutation,
  ISaveMessageMutationVariables
>

/**
 * __useSaveMessageMutation__
 *
 * To run a mutation, you first call `useSaveMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMessageMutation, { data, loading, error }] = useSaveMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSaveMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveMessageMutation,
    ISaveMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveMessageMutation,
    ISaveMessageMutationVariables
  >(SaveMessageDocument, options)
}
export type SaveMessageMutationHookResult = ReturnType<
  typeof useSaveMessageMutation
>
export type SaveMessageMutationResult =
  Apollo.MutationResult<ISaveMessageMutation>
export type SaveMessageMutationOptions = Apollo.BaseMutationOptions<
  ISaveMessageMutation,
  ISaveMessageMutationVariables
>
export const SaveManyMessagesDocument = gql`
  mutation SaveManyMessages($messages: [MessageInput]!) {
    saveManyMessages(messages: $messages) {
      id
    }
  }
`
export type ISaveManyMessagesMutationFn = Apollo.MutationFunction<
  ISaveManyMessagesMutation,
  ISaveManyMessagesMutationVariables
>

/**
 * __useSaveManyMessagesMutation__
 *
 * To run a mutation, you first call `useSaveManyMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManyMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManyMessagesMutation, { data, loading, error }] = useSaveManyMessagesMutation({
 *   variables: {
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useSaveManyMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveManyMessagesMutation,
    ISaveManyMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveManyMessagesMutation,
    ISaveManyMessagesMutationVariables
  >(SaveManyMessagesDocument, options)
}
export type SaveManyMessagesMutationHookResult = ReturnType<
  typeof useSaveManyMessagesMutation
>
export type SaveManyMessagesMutationResult =
  Apollo.MutationResult<ISaveManyMessagesMutation>
export type SaveManyMessagesMutationOptions = Apollo.BaseMutationOptions<
  ISaveManyMessagesMutation,
  ISaveManyMessagesMutationVariables
>
export const SaveWorkflowMessageDocument = gql`
  mutation SaveWorkflowMessage(
    $workflowId: ObjectId!
    $message: MessageInput!
  ) {
    savePermitMessage(permitId: $workflowId, message: $message) {
      ...MessageFields
    }
  }
  ${MessageFieldsFragmentDoc}
`
export type ISaveWorkflowMessageMutationFn = Apollo.MutationFunction<
  ISaveWorkflowMessageMutation,
  ISaveWorkflowMessageMutationVariables
>

/**
 * __useSaveWorkflowMessageMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowMessageMutation, { data, loading, error }] = useSaveWorkflowMessageMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSaveWorkflowMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveWorkflowMessageMutation,
    ISaveWorkflowMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveWorkflowMessageMutation,
    ISaveWorkflowMessageMutationVariables
  >(SaveWorkflowMessageDocument, options)
}
export type SaveWorkflowMessageMutationHookResult = ReturnType<
  typeof useSaveWorkflowMessageMutation
>
export type SaveWorkflowMessageMutationResult =
  Apollo.MutationResult<ISaveWorkflowMessageMutation>
export type SaveWorkflowMessageMutationOptions = Apollo.BaseMutationOptions<
  ISaveWorkflowMessageMutation,
  ISaveWorkflowMessageMutationVariables
>
